class VehicleTradersManagementController {
  constructor(authService, enums, lookupService, $state) {
    "ngInject";

    if(!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) { return; }

    this.authService = authService;
    this.lookupService = lookupService;
    this.$state = $state;

    this.initializeEntityList();
  }

  initializeEntityList(){
    const ctrl = this;

    const entityIds = ctrl.authService.getEntitiesForManagement(3);

    ctrl.lookupService.lookupEntityNamesByIds(entityIds)
      .then(entityNameLookups => {
        const firstItem = {
          entityId: 0,
          name: '---- Select Location ----'
        };

        this.selectedEntity = firstItem;
        ctrl.entities = [firstItem, ...entityNameLookups];
      });
  }

  updateSelectedEntity() {
    this.$state.go('vehicleTradersManagement.container', {locationId: this.selectedEntity.entityId}, {reload: true});
  }
}

export default VehicleTradersManagementController;



// WEBPACK FOOTER //
// ./client/app/components/admin/vehicleTradersManagement/vehicleTradersManagement.controller.js